module.exports = __webpack_public_path__ + "static/media/proposals-optimized.58af5da5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/slides/99-conclusion/images/proposals-optimized.jpg
// module id = 985
// module chunks = 0